import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import _ from 'underscore';
import { dispatchMulBtnIdx, dispatchMulFilter, dispatchMoreBtnIdxs } from '../../../../../store/search/actionCreator';
import styles from './index.module.scss';
import { initUrlParams, stringifySearch } from '../../../../../utils';
import { changeBrand_IdToName } from '../../../../../utils/ev';

function SelectorWrapper(props) {
  const { children, name, index, checkedValues, changeCheckedValues, listsRef, handleMouseLeave, showKey = true } = props;
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const history = useHistory();

  const {
    urlParams,
    mulBtnIdx,
    mulFilter,
    brands,
    extCates,
    categorys,
    crumb
  } = useSelector(state => state.searchReducer)

  const [showMoreBtn, setShowMoreBtn] = useState(false);
  const [showMulBtn, setShowMulBtn] = useState(true);
  const [isExpend, setIsExpand] = useState(false);

  useEffect(() => {
    // 确定更多按钮的显隐
    if (!listsRef) return;
    const ul = listsRef.current[index]
    let liWidth = 0;
    const ulPranentWidth = ul.parentElement.clientWidth;
    const lisArr = Array.from(ul.children);
    if (name === '品牌') {
      lisArr.forEach((item, index) => {
        index < 20 && (liWidth += item.clientWidth)
      })
      liWidth > ulPranentWidth && setShowMoreBtn(true)
    } else {
      lisArr.forEach((item) => {
        liWidth += item.clientWidth + parseInt(window.getComputedStyle(item).marginRight)
      })
      // name !== '高级选项' && lisArr.length < 6 && setShowMulBtn(false)
      const normalFilterStartIndex = brands.length ? 1 : 0; // 普通筛选类目的起始index
      const normalFilterEndIndex = normalFilterStartIndex + extCates.length;
      if(index < normalFilterEndIndex && index >= normalFilterStartIndex && liWidth > ulPranentWidth) setShowMoreBtn(true);
      if(lisArr.length < 6 || name === '其他分类') setShowMulBtn(false);
    }
  }, [])

  const handleMul = () => {
    setShowMoreBtn(false)
    changeCheckedValues([]);
    dispatch(dispatchMulFilter(true));
    dispatch(dispatchMulBtnIdx(index));
  }

  const handleCancel = () => {
    changeCheckedValues([]);
    dispatch(dispatchMulFilter(false));
    dispatch(dispatchMulBtnIdx(-1));
  }

  const handleOk = (e) => {
    e.stopPropagation();
    changeCheckedValues([]);
    const content = []
    const temp = checkedValues.reduce((prev, cur, index) => {
      const valueArr = cur.split('_');
      content.push(valueArr[valueArr.length - 1]);
      if(index === 0){
        return name !== '品牌' ? [`${valueArr[0]}_${valueArr[1]}`] : []
      }
      return [`${!prev[0] ? '' : prev[0] + '||'}${valueArr[1]}`]
    }, [])

    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    let _pathname = pathname.replace(/\//g,'');
    // initUrlParams(_searchParamsBody)
    if(name === '品牌'){
      _searchParamsBody.brands = _searchParamsBody.brands ? [...new Set([...(_searchParamsBody.brands), ...content])] : content;
    }else{
      _searchParamsBody.extAttrs = _searchParamsBody.extAttrs ? [...new Set([...(_searchParamsBody.extAttrs), ...temp])] : temp;
    }
    dispatch(dispatchMulFilter(false))
    dispatch(dispatchMulBtnIdx(-1));

    if (window.location.pathname.indexOf('list.html') !== -1) {
      // const { ev = '' } = _searchParamsBody;
      // const exbrand = ev.match(/exbrand_\d+/g);
      // const crumbBrand = crumb.filter(crumbItem => crumbItem.crumbName === '品牌');
      // if(exbrand?.length !== 0 && crumbBrand.length !== 0){
      //   const brandId = exbrand[0].split('_')[1];
      //   const crumbName = crumb.filter(crumbItem => crumbItem.crumbName === '品牌')[0]?.content[0];
      //   _searchParamsBody.ev = ev.replace(brandId, crumbName)
      // }
      _searchParamsBody.ev = changeBrand_IdToName(_searchParamsBody, crumb);
      _searchParamsBody.keyword =  `catid_str,,${categorys?.[1]?.cid3[0]?.id}`;
      window.location.href = `${window.location.origin}/search?${stringifySearch(_searchParamsBody)}`
    } else {
      history.push({
        pathname: _pathname,
        search: stringifySearch(_searchParamsBody)
      })
    }
  }

  const handleMore = () => {
    setIsExpand(!isExpend);
    dispatch(dispatchMoreBtnIdxs(index))
  }

  const cancelMulItem = (value) => {
    const _checkedValues = checkedValues.filter(item => item !== value);
    changeCheckedValues(_checkedValues)
  }

  return (
    <div className={styles["s-line"]} key={name}>
      <div className={styles["sl-wrap"]} onMouseLeave={handleMouseLeave}>
        {showKey && <div className={styles["sl-key"]} style={!index ? { padding: '0 0 0 10px' } : {}}>{name}：</div>}
        <div className={styles["sl-value"]}>
          {children}
          {
            mulFilter && mulBtnIdx === index && checkedValues.length > 0 && (
              <div className={styles["sl-selected"]}>
                <span className={styles["sl-selected-key"]}>已选条件：</span>
                <ul className={styles["sl-selected-list"]}>
                  {
                    checkedValues.map((checkedValue) => {
                      const checkedArr = checkedValue.split('_');
                      return (
                        <li className={styles.selected} onClick={() => cancelMulItem(checkedValue)} key={checkedValue}>
                          <i></i>
                          {checkedArr[checkedArr.length - 1]}
                        </li>

                      )
                    })
                  }
                </ul>
              </div>
            )
          }
          {
            mulFilter && mulBtnIdx === index && <div className={styles["sl-btns"]}>
              <button className={`${styles["btn"]} ${styles["btn-primary"]} ${checkedValues.length <= 0 && styles["disabled"]}`} onClick={handleOk}>确定</button>
              <button className={`${styles["btn"]} ${styles["btn-default"]}`} onClick={handleCancel}>取消</button>
            </div>
          }
        </div>
        {
          index === undefined ? null :
            <div className={styles["sl-ext"]}>
              {<button className={`${styles["sl-e-more"]} ${isExpend ? styles.opened : null}`} onClick={handleMore} style={{ visibility: showMoreBtn ? 'visible' : 'hidden' }} >{isExpend ? '收起' : '更多'}<i></i></button>}
              { showMulBtn && mulBtnIdx !== index && <button className={styles["sl-e-multiple"]} onClick={handleMul}>多选<i></i></button>}
            </div>
        }

      </div>
    </div>
  )
}

export default SelectorWrapper;